import React, {Component} from 'react';
import {connect} from 'react-redux';
import StackOptions from './stack-options';
import Action from 'components/organisms/nhl-team-stacking/actions';
import ChooseTeamsRandomly from './choose-teams-randomly';
import CombinationOptions from './combination-options';
import ForceTeamsToStacking from './force-teams-to-stacking';
import SingleStackOptions from './single-stack-options';

class Stacks extends Component {
    componentDidMount() {
        this.props.dispatch(Action.setTeams(this.props.games));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.props.dispatch(Action.setTeams(this.props.games));
    }

    render() {
        return (
            <div className="white-box">
                <h2 className="mb15">Stack Rules</h2>
                <div className="checkbox mb15">
                    <ChooseTeamsRandomly />
                </div>
                {/*<div className="checkbox mb15">*/}
                {/*    <ForceTeamsToStacking/>*/}
                {/*</div>*/}
                <CombinationOptions />
                <div className="stack-filter full-width">
                    <SingleStackOptions />
                    {/*<StackOptions stackNumber={1}/>*/}
                    {/*<StackOptions stackNumber={2}/>*/}
                    {/*<StackOptions stackNumber={3}/>*/}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        playersData: {
            filters: {games},
        },
    } = state;

    return {
        games,
    };
}

export default connect(mapStatesToProps)(Stacks);
